module.exports = __webpack_public_path__ + "static/media/SOTA MILLENNIA ECLIPSE.7f770e3a.png";